export const ERROR_NOT_NUMERIC_VALUE = 'Необходимо ввести числовое значение';
export const ERROR_MAX_PAGE_NUMBER_EXCEEDED = 'Введенное значение превышает общее количество страниц';
export const ERROR_MIN_PAGE_LIMIT = 'Введенное значение не может быть меньше 1';
